// extracted by mini-css-extract-plugin
export var addButton = "_mp-0";
export var border = "_mp-8";
export var check = "_mp-h";
export var danger = "_mp-6";
export var dropdownContainer = "_mp-1";
export var editModalBody = "_mp-j";
export var footerContainer = "_mp-i";
export var fullWidth = "_mp-a";
export var hide = "_mp-9";
export var icon = "_mp-3";
export var input = "_mp-7";
export var inputFlex = "_mp-b";
export var inputWrapper = "_mp-c";
export var manualFocus = "_mp-5";
export var optionButton = "_mp-4";
export var pillWrapper = "_mp-e";
export var pointer = "_mp-2";
export var showOverflow = "_mp-f";
export var tagsFlex = "_mp-d";
export var xButton = "_mp-g";